import React, { useEffect, useState } from 'react';
import Noticias from "./Noticias";
import Videos from "./Videos";
import LayoutBanner from "./LayoutBanner";
import Novidades from './Novidades';
import { Box, Modal, Fade } from '@mui/material';
import LeisMunicipais from './InicioLeisMunicipais';
import TitleSection from './utils/TittleTheme';
import RandomNoticias from './utils/RamdomNoticias';
import InfoCards from './utils/infoCard';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { camara, cidade, KEY_REF } from './adm/admin/firebaseConfig';
import Vereadores from './legislacao/VereadoresGrid';

const WelcomePopup = () => {
    const [step, setStep] = useState(1); // 1: Logo 1, 2: Main Banner
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(null);

    // Forçar popup a abrir para testes
    useEffect(() => {
        console.log('Popup useEffect: Verificando sessionStorage e definindo open');
        // sessionStorage.removeItem('hasSeenPopup'); // Descomente para testes
        const hasSeenPopup = sessionStorage.getItem('hasSeenPopup');
        if (!hasSeenPopup) {
            setOpen(true);
            sessionStorage.setItem('hasSeenPopup', 'true');
        } else {
            console.log('Popup já exibido nesta sessão');
        }
    }, []);

    // Lógica de sequência de animação
    useEffect(() => {
        if (open) {
            console.log('Popup aberto, step:', step);
            if (step === 1) {
                const timer1 = setTimeout(() => setStep(2), 3000); // Logo 1 por 3 segundos
                return () => clearTimeout(timer1);
            }
        }
    }, [step, open]);

    const handleClose = () => {
        setOpen(false);
    };

    // Verificar se as imagens carregam corretamente
    const handleImageError = (imgName) => {
        setError(`Erro ao carregar a imagem: ${imgName}`);
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(5px)', // Efeito de desfoque no fundo
                outline: 'none', // Remove bordas de foco
                border: 'none', // Remove qualquer borda
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        maxWidth: { xs: '95vw', md: '700px' }, // Espaço para animação
                        maxHeight: { xs: '85vh', md: '700px' }, // Espaço para banner
                        backgroundColor: 'transparent', // Fundo transparente
                        boxShadow: 'none', // Sem sombras
                        outline: 'none', // Sem bordas de foco
                        border: 'none', // Sem bordas
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 4, // Espaço interno para animação
                    }}
                    className="animate__animated animate__zoomIn"
                >
                    {error && (
                        <Box sx={{ color: 'red', textAlign: 'center', p: 2 }}>
                            {error}
                        </Box>
                    )}
                    {step === 1 && !error && (
                        <img
                            src="/imagens/logo_datas.webp"
                            alt="Logo 1"
                            onError={() => handleImageError('logo_datas.webp')}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '250px', // Espaço para rotação
                                objectFit: 'contain',
                                animation: 'rotateIn 1.5s ease-in-out, pulse 2s ease-in-out infinite 1.5s',
                            }}
                        />
                    )}
                    {step === 2 && !error && (
                        <Box
                            sx={{
                                width: '100%',
                                height: '100%',
                                position: 'relative',
                                cursor: 'pointer', // Indica que o banner é clicável
                                outline: 'none', // Sem bordas de foco
                                border: 'none', // Sem bordas
                            }}
                            onClick={() => window.open('https://www.instagram.com/bodenaruagurjaopb/', '_blank')}
                        >
                            <img
                                src="/imagens/bnr.webp"
                                alt="Main Banner"
                                onError={() => handleImageError('bnr.webp')}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain', // Mantém proporção
                                    maxWidth: { xs: '100%', md: '600px' },
                                    maxHeight: { xs: '80vh', md: '600px' },
                                    animation: 'slideIn 1s ease-in-out',
                                    outline: 'none', // Sem bordas de foco
                                    border: 'none', // Sem bordas
                                }}
                            />
                        </Box>
                    )}
                    {step === 2 && (
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: -50,
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                        >
                            <button
                                onClick={handleClose}
                                className="bg-white text-red-600 border border-red-500 px-6 py-2 rounded-xl shadow-md hover:bg-red-50 hover:text-red-700 hover:border-red-600 active:scale-95 transition-all duration-300 ease-in-out"
                            >
                                Fechar
                            </button>
                        </Box>

                    )}
                    <style>
                        {`
              @keyframes rotateIn {
                from {
                  transform: rotate(0deg) scale(0.5);
                  opacity: 0;
                }
                to {
                  transform: rotate(360deg) scale(1);
                  opacity: 1;
                }
              }
              @keyframes pulse {
                0% {
                  transform: scale(1);
                }
                50% {
                  transform: scale(1.05);
                }
                100% {
                  transform: scale(1);
                }
              }
              @keyframes slideIn {
                from {
                  transform: translateY(100%);
                  opacity: 0;
                }
                to {
                  transform: translateY(0);
                  opacity: 1;
                }
              }
            `}
                    </style>
                </Box>
            </Fade>
        </Modal>
    );
};

export default function Inicio({ config }) {
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    {camara ? (
                        <title>{`Inicio - Camara Municipal ${cidade}`}</title>
                    ) : (
                        <title>{`Inicio - ${cidade}`}</title>
                    )}
                </Helmet>
            </HelmetProvider>
            {/* {!camara && KEY_REF === '2506509' && (
                <WelcomePopup />
            )} */}


            {config?.design?.noticias && <Noticias config={config} />}
            {config?.videos?.titulo && config?.design?.videos && <Videos config={config} />}
            {config?.bannerDestaque && config?.design?.bannerDestaque && (
                <LayoutBanner link="#" src={config?.bannerDestaque} />
            )}
            {config?.design?.infoCards && <InfoCards config={config} />}
            {/* {!camara && KEY_REF === '2506509' && (
                <LayoutBanner
                    link="https://play.google.com/store/apps/details?id=com.bigstarinformatica.gurjaoplus&hl=en_US"
                    src="/imagens/gurjaoplus.png"
                />
            )} */}
            <Novidades config={config} />
            {!camara && KEY_REF === '2506509' && (
                <LayoutBanner link="/arquivos/farmaciabasica" src="/imagens/farmacia.png" />
            )}
            {camara && <Vereadores />}
            {config?.design?.noticiasMaisLidas && (
                <>
                    <TitleSection
                        config={config}
                        title={'NOTÍCIAS MAIS LIDAS'}
                        subtitle={'Você está vendo as notícias mais lidas de todo o nosso portal'}
                        link={'/noticias/todas'}
                        todos={true}
                        share={true}
                    />
                    <Box sx={{ maxWidth: 1400, margin: '0 auto', padding: '0 16px' }}>
                        <RandomNoticias config={config} quantidade={6} />
                    </Box>
                </>
            )}
            {!camara && <LayoutBanner link="/legislacao/aldir_blanc" src="/imagens/aldirblanc.png" />}
            {config?.design?.leisMunicipais && <LeisMunicipais config={config} />}
            {!camara && <LayoutBanner link="#" src="/imagens/bannergov1.gif" />}
        </>
    );
}